import { CUIDEI_BRAND_COOKIE, CUIDEI_PARTNER_NAME } from 'constants/cuidei'
import { useBrandCookie } from 'hooks/helpers/useBrandCookie'
import { useEffect, useState } from 'react'
import { useAppSelector } from 'redux/store'

// Resolve after hydration so direct legal/PIX links work without an entry cookie.
export const useIsCuideiDomain = (): boolean => {
  const [isCuideiDomain, setIsCuideiDomain] = useState(false)
  useEffect(() => {
    const hostname = window.location.hostname.toLowerCase()
    setIsCuideiDomain(hostname === 'cuidei.com.br' || hostname.endsWith('.cuidei.com.br'))
  }, [])
  return isCuideiDomain
}

/**
 * True when the current session belongs to the Cuidei brand space.
 *
 * Mirrors useIsMedlevePage / useIsIshaPage: the brand cookie is set on the
 * Cuidei landing/QR entry, and once an account exists the patient's
 * partnerName === 'cuidei' keeps the patient area branded across reloads.
 */
export const useIsCuideiPage = (): boolean => {
  const isCuideiDomain = useIsCuideiDomain()
  const { profile } = useAppSelector((state) => state.auth)

  const hasCookie = useBrandCookie(CUIDEI_BRAND_COOKIE)
  const isCuideiUser = profile?.partnerName?.toLowerCase() === CUIDEI_PARTNER_NAME

  return Boolean(isCuideiDomain || hasCookie || isCuideiUser)
}
